const CONTENT_POLICY_PATTERNS = [
  'content_policy_violation',
  'content policy',
  'sensitive content',
  'safety filter',
  'safety system',
  'blocked by',
  'policy violation',
  'partner_validation_failed',
]

const RATE_LIMIT_PATTERNS = [
  'rate limit',
  'rate_limit',
  'too many requests',
  '429',
  'quota exceeded',
]

const TIMEOUT_PATTERNS = ['timed out', 'timeout', 'deadline exceeded']

const STRUCTURED_NOISE = /\{'loc'|{"loc"|Traceback \(most recent|https?:\/\/docs\.\w+\.\w+\/errors/

export function sanitizeNodeError(raw: string | undefined): string | undefined {
  if (!raw) return raw

  const lowered = raw.toLowerCase()

  if (CONTENT_POLICY_PATTERNS.some((p) => lowered.includes(p))) {
    return "Content was flagged by the provider's safety filter. Try adjusting your prompt or reference images."
  }

  if (RATE_LIMIT_PATTERNS.some((p) => lowered.includes(p))) {
    return 'Rate limit reached. Please wait a moment and try again.'
  }

  if (TIMEOUT_PATTERNS.some((p) => lowered.includes(p))) {
    return 'Generation timed out. Please try again.'
  }

  if (lowered.includes('all providers failed')) {
    return 'Generation failed across all available providers. Please try again or adjust your inputs.'
  }

  // Internal Python wrappers (orchestrator re-raises apply_result / TypeError
  // verbatim). Hide the wrapper from users — backend logs hold the full trace.
  if (lowered.includes('apply_result raised') || lowered.includes('typeerror')) {
    return 'A backend error occurred while saving the generated asset. Please try again.'
  }

  if (raw.length > 200 || STRUCTURED_NOISE.test(raw)) {
    return 'An error occurred during generation. Please try again.'
  }

  return raw
}
